import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import AddressWhitelistPage from './AddressWhitelistPage';
import UspsAddressProcessPage from '../usps-address-process/UspsAddressProcessPage';

const TAB_KEY_WHITELIST = 'whitelist';
const TAB_KEY_USPS = 'usps';

const AddressWhitelistTabsPage: React.FC = () => {
  const { t } = useTranslation();
  const [activeKey, setActiveKey] = useState<string>(TAB_KEY_WHITELIST);

  return (
    <div>
      <Tabs
        activeKey={activeKey}
        onChange={setActiveKey}
        destroyInactiveTabPane
        className="pt-2 px-2"
        items={[
          {
            key: TAB_KEY_WHITELIST,
            label: t('mapTool.addressWhitelistTabs.tabWhitelist'),
            children: <AddressWhitelistPage />,
          },
          {
            key: TAB_KEY_USPS,
            label: t('mapTool.addressWhitelistTabs.tabUsps'),
            children: <UspsAddressProcessPage />,
          },
        ]}
      />
    </div>
  );
};

export default AddressWhitelistTabsPage;
